import AWS from "aws-sdk";
import { AWS_ENV } from "../environment";

// Configure AWS and Amplify
AWS.config.region = AWS_ENV.region;

export default AWS;
